// @flow
import React from 'react'
import { connect } from 'react-redux'
import gql from 'graphql-tag'
import { graphql } from 'react-apollo'
import { viewerFragment } from 'api/fragments'
import { bindActionCreators } from 'redux'
import { actions as accountActions } from 'redux/modules/account'
import AccountUseCase, {
  type AccountUseCaseType,
  AccountUseCaseActionsBridge,
} from 'usecases/AccountUseCase'
import AccountTemplate from 'components/templates/AccountTemplate'

class SignOutPageContainer extends React.Component<*> {
  componentDidMount() {
    const { accountUseCase } = this.props
    accountUseCase.signOut()
  }

  render() {
    const { config } = this.props
    return <AccountTemplate title="" currentUser={null} config={config} />
  }
}

function mapStateToProps(state) {
  return state
}

function mapDispatchToProps(dispatch: Dispatch<*>) {
  const bindActions = Object.assign(AccountUseCaseActionsBridge)
  return { actions: bindActionCreators(bindActions, dispatch) }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AccountUseCase(SignOutPageContainer))
